import React from 'react';

const Footer = () => {
    return (
        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3">
            <div>
            <p> All right resurved &copy;Grocery Dealer </p>
            </div>
            <div>
                <p>Facebook</p>
                <p>LinkedIn</p>
                <p>Twitter</p>
            </div>
            <div>
                <h5>Our Services</h5>
                <p> Product Sale</p>
                <p> Contact Us </p>
            </div>
            
        </div>
    );
};

export default Footer;